import useStyles from "../../style/js-style/containers/doc-viewer/DocViewerMarkdownStyle";
import ReactMarkdown from 'react-markdown';
import i18next from "i18next";
import EAIcon from "components/common/EAIcon";
import moment from "moment"; 
import remarkGfm from "remark-gfm";

const DocViewerMarkdown = ({ summaryResults }) => {
  const { classes } = useStyles();
  return (
    summaryResults?.extractedSummary ? <div className={classes.viewer}>
      <div className={classes.info}>
        <div>
          <EAIcon icon={"ai"} />
          {i18next.t("viewer.summarySubtitle")}
        </div>
        {summaryResults?.extractedSummaryDate && <span> Le {moment(summaryResults.extractedSummaryDate).format('DD-MM-YYYY')}</span>}
      </div>
      <div className={classes.title}>{i18next.t("viewer.summaryTitle")}</div>
      {<ReactMarkdown remarkPlugins={[remarkGfm]}>{summaryResults.extractedSummary}</ReactMarkdown>}
    </div> : <></>
  )
}
export default DocViewerMarkdown;